export default __webpack_public_path__ + "static/media/hover.6c2bf2b6.svg";